// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ReportTotalsSchema = z.object({
  id: z.number().int(),
  name: z.coerce.string().min(1),
  projects: z.array(z.unknown()),
  duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }),
  estimated_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }),
  billed_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }),
  unbilled_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }),
  billable_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }),
  non_billable_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }),
  cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }),
  estimated_cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }),
  billed_cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }),
  unbilled_cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }),
  internal_cost: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }),
  profit: z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }),
  profitability: z.number(),
});
